export default {
  name: 'SubscriptionTypes',
  props: {
    types: {
      Array,
      default: () => [{
        id: null,
        name: null,
        duration: 1
      }]
    }
  },
  // computed: {
  //   sortedTypes () {
  //     return [...this.types].sort((a, b) => {
  //       return (+a.duration || 0) - (+b.duration || 0)
  //     })
  //   },
  //   bestValueId () {
  //     if (!this.types || !this.types.length) return null
  //     const best = [...this.types].sort((a, b) => (+b.duration || 0) - (+a.duration || 0))[0]
  //     return best ? best.id : null
  //   }
  // },
  computed: {
    sortedTypes() {
      return [...this.types].sort((a, b) => {
        return (+b.duration || 0) - (+a.duration || 0);
      });
    },
    bestValueId() {
      if (!this.types || !this.types.length) return null;
      const best = [...this.types].sort((a, b) => (+b.duration || 0) - (+a.duration || 0))[0];
      return best ? best.id : null;
    }
  },
  filters: {
    billingType(val) {
      return val > 1 ? 'annually' : val ? 'monthly' : '';
    }
  }
};